import React from 'react'
import _ from 'lodash'

// Known issue - the iframe height will NOT resize here if the content inside of
// the frame changes as the result of some user interaction (i.e. clicking to
// increase the height of the Routes index table, uploading a whole bunch of
// TCX files on the Upload page, etc).
//
// For now, I'm calling this  #wontfix, because both polling or trying to listen
// for every event that could possibly impact the height of an iframe content
// is a total can of worms
export class AutoHeightIframe extends React.PureComponent {
  state = {
    height: 0
  }

  getFrameDoc = () => {
    // IE workaround, see https://stackoverflow.com/a/3999191
    return this._iframe && (this._iframe.contentDocument || this._iframe.contentWindow.document)
  }

  onFrameLoaded = (e) => {
    const doc = this.getFrameDoc()
    // proxy the event through so this behaves more like a normal iframe
    this.props.onLoad && this.props.onLoad(e)
    // wait for the content to be ready before running layout functions
    if (doc.attachEvent ? doc.readyState === 'complete' : doc.readyState !== 'loading') {
      this.onFrameContentReady()
    } else {
      doc.addEventListener('DOMContentLoaded', this.onFrameContentReady)
    }
  }

  onFrameContentReady = () => {
    window.addEventListener('resize', this.onWindowResize)
    this.computeHeight()
    this.beginPollingForHeightChange()
  }

  componentWillUnmount () {
    window.removeEventListener('resize', this.onWindowResize)
    this.stopPollingForHeightChange()
  }

  beginPollingForHeightChange = () => {
    this._tickTimerId = setInterval(this.pollTick, 200)
  }

  stopPollingForHeightChange = () => {
    clearInterval(this._tickTimerId)
  }

  pollTick = () => {
    // executes every 200ms while the component is mounted
    this.computeHeight()
  }

  onWindowResize = _.throttle(() => {
    this.computeHeight()
  }, 200)

  computeHeight = () => {
    const doc = this.getFrameDoc()
    const height = doc.body.scrollHeight
    this.setState({ height })
  }

  render () {
    const { style, ...props } = this.props
    const { height } = this.state
    return <iframe
      {...props}
      ref={r => { this._iframe = r }}
      onLoad={this.onFrameLoaded}
      style={{ ...style, height }} />
  }
}
